import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';
import { Button } from '@HomaHealth/ui-component-library/lib/_AIQ-components';

interface ModalBottomBarProps {
  onReset: () => void;
  onCancel: () => void;
  onSave: () => void;
  isSaveDisabled: boolean;
}

const useStyles = makeStyles()({
  bottomBar: {
    display: 'flex',
    gap: '0.75rem',
    justifyContent: 'flex-end',
    marginTop: 'auto',
  },
});

export const ModalBottomBar = ({
  onReset,
  onCancel,
  onSave,
  isSaveDisabled,
}: ModalBottomBarProps) => {
  const messages = componentConstants.ORGANISMS.COHORT_DETAILS;

  const { classes } = useStyles();

  return (
    <Box className={classes.bottomBar}>
      <Button
        label={messages.RESET_FILTER}
        variant="outlined"
        onClick={onReset}
      />
      <Button label={messages.CANCEL} variant="outlined" onClick={onCancel} />
      <Button
        label={messages.SAVE}
        variant="contained"
        disabled={isSaveDisabled}
        onClick={onSave}
      />
    </Box>
  );
};
